import { IRegionFAQ } from 'api/region/types';
import { BlockContent } from 'components/blocks/BlockContent';
import { BlockHeader } from 'components/blocks/BlockHeader';
import { BoxWithShadow } from 'components/blocks/BoxWithShadow';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { RefObject, useMemo } from 'react';
import { CollapsableList } from 'components/common/CollapsableList';
import { SanitizeMode, useSanitizedHtmlProps } from 'util/sanitized';

import { IHTMLParsedData, parseHTMLtoList } from 'util/parseHTMLtoList';
import styles from './styles.module.scss';

export const RegionFAQ = ({
  regionTitle,
  regionFAQ,
  refScroll,
  placeholders,
}: {
  regionTitle: string,
  regionFAQ: IRegionFAQ,
  refScroll?: RefObject<HTMLDivElement>,
  placeholders?: Record<string, string>,
}) => {
  const { t } = useOTSTranslation('common');

  if (!regionFAQ.descriptionRegion) {
    return null;
  }

  const { list, text } = useMemo<IHTMLParsedData>(
    () => parseHTMLtoList(regionFAQ.descriptionRegion, placeholders || {}),
    [regionFAQ],
  );

  const htmlProps = useSanitizedHtmlProps(text || '', SanitizeMode.NormalWithImages);

  return (
    <div className={styles.regionFAQ} ref={refScroll}>
      <BoxWithShadow>
        <BlockHeader title={t('region.resortGuide.FaqTitle', { region: regionTitle })} />
        <BlockContent className={styles.boxFAQ}>
          <div {...htmlProps} />
          <CollapsableList
            data={list}
            isFirstOpenByDefault
          />
        </BlockContent>
      </BoxWithShadow>
    </div>
  );
};
